import React, {createElement} from 'react';

export interface ContainerProps {
    style?: object;
    width?: number | string;
    isCenter?: boolean;
    children?: any;
}


const Container: React.FC<ContainerProps> = (props) => {
    const { style, width, isCenter, children } = props;



    return (
        <div style={{ position: 'relative', width, margin: isCenter ? '0 auto' : '', boxSizing: 'border-box', ...style }}>
            {children}
        </div>
    );
};

Container.displayName = '容器';

export default Container;
